import { DateTime } from 'luxon'

import type { InvoiceAttachmentModel } from './types'

const currentDateTime = DateTime.now()
const nextWeek = currentDateTime.plus({ days: 7 }).toFormat('yyyy-MM-dd')

export type InvoiceModel = {
  cache_key: number,
  id: number,
  address?: string,
  amount_paid?: number,
  approved: boolean,
  approved_order_item_count?: number,
  attachment?: string,
  attachment_file_name?: string,
  attachments?: InvoiceAttachmentModel[],
  campaign_id?: number,
  created_by?: string,
  creditor_id: number,
  creditor_name?: string,
  creditor_type: string,
  currency_code?: string,
  data?: {
    xero_id?: number,
  },
  dates: {
    created: string,
  },
  debtor_id?: number,
  debtor_name: string,
  debtor_type?: string,
  debtor?: any,
  due_date?: string,
  links?: {
    pdf?: string,
  },
  notes?: string,
  order_id?: number,
  order_title?: string,
  paid: boolean,
  purchase_order?: string,
  reference?: string,
  title?: string,
  total: number,
  type: 'Invoice',
  void: boolean,
  item_ids: number[],
}

export type InvoiceRequestOptions = {
  include_credit_note_campaign?: boolean,
  include_credit_note_items?: boolean,
  include_invoice_attachments?: boolean,
  include_invoice_campaign?: boolean,
  include_invoice_creditor?: boolean,
  include_invoice_items?: boolean,
}

const state = {
  address: '',
  approved: false,
  campaign_id: undefined,
  creditor_id: undefined,
  created_by: 'creditor',
  creditor_type: '',
  currency_code: '',
  data: {},
  dates: {},
  debtor: {},
  debtor_id: undefined,
  debtor_name: '',
  debtor_type: '',
  due_date: nextWeek,
  id: null,
  notes: '',
  order_id: undefined,
  order_title: '',
  paid: false,
  purchase_order: '',
  reference: '',
  total: undefined,
  void: false,
}

export const requiredFields = []

export default state
